import { api } from "@/api";
import {
  ClearMatchSuspensionsParams,
  ClearMatchSuspensionsResponse,
} from "@/types/ApiResponses/SportEvent";

export const clearMatchesSuspensions = async (
  params: ClearMatchSuspensionsParams
): Promise<ClearMatchSuspensionsResponse> => {
  const res = await api.client.delete(`/sport-events-new/suspensions`, {
    params,
  });
  return res.data;
};
